(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fb-careers-link"] && !Shopify.designMode) return;
  try {
    (() => {
    let observer;

    function watchCareersPopups() {
      if (observer) observer.disconnect();

      const tab = document.querySelector('.fb-careers-link--tab');
      if (!tab) return;

      const popups = ['popupModal']
        .map(id => document.getElementById(id))
        .filter(Boolean);
      const sync = () => {
        tab.hidden = popups.some(popup => getComputedStyle(popup).display !== 'none');
      };

      observer = new MutationObserver(sync);
      popups.forEach(popup => observer.observe(popup, {
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden']
      }));
      sync();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watchCareersPopups, { once: true });
    } else {
      watchCareersPopups();
    }
    document.addEventListener('shopify:section:load', watchCareersPopups);
  })();
  } catch(e) { console.error(e); }
})();

})();
